export const TERMS_CONDITIONS_FEATURE_FLAG = 'PCC_ECTTermsAndConditions';
export const PRIVACY_POLICY_FLAG = 'PCC_ECTPrivacyPolicy';
export const CAT_LEGAL_TERMS_FLAG = 'PCC_FooterLegalTermsLinkRedirection';
export const PCC_PDP_FBT_FEATURE_FLAG = 'PCC_PDPFBTFeature';
export const PCC_HEADLESS_SAVED_LISTS_PAGE = 'PCCHeadlessSavedListsPage';
export const PCC_HEADLESS_ORDER_HISTORY_PAGE =
  'PCC_HeadlessOrdHistorySearchPageFlag';
export const PCC_HEADLESS_QUOTES_PAGE = 'PCC_HeadlessPendingQuoteDetailsFlag';
export const PCC_CONTROL_CENTER_BLOCK_FLAG = 'PCCControlCenterFlagBlocks';
export const PCC_UPDATE_PDPCTA_TO_SEA_PARTS = 'PCC_UpdatePDPCTAToSeaParts';
export const IS_CUSTOMER_SUPPORT_ENABLE = 'isCustomerSupportEnabled';
export const PCC_HEADLESS_ADDRESS_BOOK_PAGE = 'PCCHeadlessAddressBookFeature';
export const PCC_NAVIGATION_MENU_UPDATES = 'PCCNavigationMenuUpdatesFlag';
export const PCC_HEADLESS_SAVED_LISTS_DETAIL_PAGE =
  'PCC_HeadlessSavedListsDetailsFlag';
export const PCC_CHECKOUT_FOR_CSR = 'PCCCheckoutForCSR';
export const PCC_DEALER_SHARE_QUOTE_CONFIRMATION_FLAG =
  'PCC_DealerShareQuoteConfirmationWithCustomer';
export const PCC_TAX_INFORMATION_MESSAGE_FLAG =
  'PCC_TaxInformationMessagesFlag';
export const PCC_HEADLESS_LOGOUT_SESSION_EXPIRED_PAGE_FLAG =
  'PCC_HeadlessLogoutSessionExpiredPageFlag';
export const PCC_CUSTOMER_SUPPORT_GUEST_ORDER_DETAILS_PII_REMOVAL =
  'PCC_CustomerSupportGuestOrderDetailsPIIRemoval';
export const PCC_CURRENT_CART_FLAG = 'PCC_ControlCenterBlocksCurrentCart';
export const PCC_HEADLESS_SHOPPING_CART_FLAG = 'PCC_HeadlessBlocksShoppingCart';
export const PCC_AVAILABILITY_FOR_UNMERGED_CART_FLAG =
  'PCC_AvailabilityForUnmergedCart';
export const PCC_RECENTLY_VIEWED_FLAG = 'PCC_ControlCenterBlocksRecentlyViewed';
export const PCC_RECENT_ORDER_FLAG = 'PCC_ControlCenterBlocksRecentOrders';
export const PCC_SAVED_LIST_FLAG = 'PCC_ControlCenterBlocksSavedLists';
export const PCC_CORE_TRACKING_FLAG = 'PCC_ControlCenterBlocksCoreTracking';
export const PCC_CUSTOMER_SUPPORT_HELP_CENTER_PAGE =
  'PCCCustomerSupportHelpCenter';
export const PCC_AVAIL_REMOVE_INTERIM_STOCK_FLAG =
  'PCC_availRemoveInterimStockFlag';
export const PCC_ASSOCIATE_EQUIPMENT_TO_SAVED_LIST =
  'PCC_AssociateEquipmentToSavedList';
export const PCC_AVAILABILITY_BY_BRANCH_LOCATION =
  'PCCHeadlessAvailabilityByBranchLocation';
export const PCC_SHARE_SAVED_LIST_DCN_SEARCH =
  'PCC_DealerUserShareSavedListDcnSearchFlag';
export const PCC_HEADLESS_CAL_ORDERS_TO_APPROVE_SEARCH_PAGE =
  'PCC_HeadlessCalOrdersToApproveSearchPage';
export const PCC_DEALER_LOCATION_FLAG = 'PCC_ECTDealerLocationFlag';
export const PCC_INSTANCEAPI_SERVICE_INSIGHT_FLAG =
  'PCC_InstanceAPI_ServiceInsightFlag';
export const PCC_HEADLESS_REQUEST_SERVICE_FLAG =
  'PCCHeadlessRequestServiceFlag';
export const PCC_HIDING_MAP_FEATURE_FLAG = 'PCC_HidingMapFeatureFlag';
export const PCCHeadlessDealerMessagesFlag =
  'PCCHeadlessRedesignForDealerAndEcommerceMessagesFlag';
export const PCC_MarketingRibbon_HeadlessPages =
  'PCC_MarketingRibbon_HeadlessPages';
export const PCC_HEADLESS_INSTANCE_API_FLAG = 'PCCHeadlessInstanceAPIFlag';
export const PCC_SEARCH_RESULTS_HEADLESS = 'PCCSearchResultHeadless';
export const PCC_CUSTOMER_SUPPORT_DISABLE_PCC_ORDER_EMAIL =
  'PCC_CustomerSupportDisablePCCOrderEmail';
export const PCC_HIDE_METHODS_FOR_NOVICE_CUSTOMERS =
  'PCC_HideMethodsForNoviceCustomers';
export const PCC_NAMED_ENTITY_RECOGNITION = 'PCC_NamedEntityRecognition';
export const PCC_HEADLESS_ASSETLANDINGPAGE = 'PCC_Headless_AssetLandingPage';
export const PCC_HEADLESS_BLOCKS_CATEGORY_PAGE =
  'PCC_HeadlessBlocksCategoryPages';
export const PCC_HEADLESS_BLOCKS_PDP_TOP_SECTION =
  'PCC_HeadlessBlocksPDP_TopSection';
export const PCC_CATCARDCREDITS_TRANSLATIONS =
  'PCC_CatCardCredits_translations';
export const PCC_RAGE_SLIDER_SEARCH_PAGE = 'PCC_RangeSliderSearchPage';
export const PCC_HEADLESS_SAVED_LIST_DETAILS_OPTIMIZATION_PAGE =
  'PCC_HeadlessSavedListsDetailsOptimizationFlag';
export const PCC_HEADLESS_SERVICE_INSIGHTS_CUSTOMER_FLAG =
  'PCC_CustomerAcSectionAggregatedServiceInsightsViewFlag';
export const PCC_FEDERATED_SEARCH = 'PCC_FederatedSearch';
export const PCC_SEARCH_RESULTS_SPECIFICATIONS_DRAWER =
  'PCC_SearchResults_SpecificationsDrawer';
export const PCC_Headless_PDPEMURGE = 'PCC_Headless_PDPEMURGE';
export const PCC_PDP_MOBILE_STICKY_CTA = 'PCC_PDP_StickyCTAMobileView';
export const PCC_FOOTER_DESIGN_UPDATE = 'PCC_FooterDesignUpdate';
export const PCC_PDP_HEADER_UPDATE_MOBILE = 'PCC_PDP_HeaderUpdateMobileView';
export const PCC_CVR_PROMOTE_ENROLLMENT = 'PCC_CVRPromoteEnrollment';
export const PCC_CVR_IMPROVE_VISIBILITY = 'PCC_CVRImproveVisibility';
export const PCC_CAT_VANTAGE_REWARDS_FLAG = 'PCC_CatVantageRewardsFlag';
export const PCC_HEADLESS_BLOCKS_SSO_PAGE = 'PCC_HeadlessBlocksSSO_Page';
export const PCC_FREQUENTLY_BOUGHT_TOGETHER = 'PCC_FrequentlyBoughtTogether';
export const PCC_SIS_TO_PCC_CART_IMPORT_FLAG = 'PCC_SIStoPCCCartImportFlag';
export const PCC_PDP_PARTS_DIAGRAM_MOBILE = 'PCC_PDP_PartsDiagramMobileView';
export const PCC_SORT_FILTER_REDESIGN_SEARCH = 'PCC_SortFilterRedesignSearch';
export const PCC_PLP_VIEW_SPECS_DRAWER = 'PCC_PLP_ViewSpecsDrawer';
export const PCC_CAT_CARD_FINANCING_OFFER_STATUS_PAGE =
  'PCC_CatCardFinancingOfferStatusPage';
export const PCC_HEADLESS_BUY_AGAIN_VIEW_ALL = 'PCCHeadlessBuyAgainViewAllFlag';
export const PCC_CATEGORY_SUBCATEGORY_ESPOT_CONTAINERS =
  'pcc-release-category-subcategory-espot-containers';
export const PCC_BLOCKS_ORDER_CONFIRMATION_PAGE_CLEANUP =
  'pcc-release-blocks-order-confirmation-page-cleanup-feature-flag';
export const PCC_SEARCH_RESULTS_MEQ_MOBILE_UPDATES =
  'PCC_SearchResults_MEQMobileUpdates';
export const PCC_PLP_MEQ_MOBILE_UPDATES = 'PCC_PLP_MEQMobileUpdates';
export const PCC_PDP_HeaderUpdateMobileView = 'PCC_PDP_HeaderUpdateMobileView';
export const PCC_HEADLESS_BLOCKS_RECENTLY_VIEWED_PAGE =
  'PCCHeadlessBlocksRecentlyViewedPage';
export const PCC_CORE_TRACKING_HEADLESS_PAGE_FEATURE_FLAG =
  'pcc-release-headless-core-tracking-page';
export const PCC_HIDE_DELIVERY_INSTRUCTIONS_PUD =
  'pcc-release-hide-delivery-instructions-pud';
export const PCC_CustomerSupport_Enable_Dealer_PostOrder_Modificationsv1 =
  'PCC_CustomerSupportEnableDealerPostOrderModificationsv1';
export const PCC_BLOCKS_ORDER_CONFIRMATION_PAGE_FEATURE_FLAG =
  'PCC_BlocksOrderConfirmationPageFeatureFlag';
